import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, getTablebySql } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnButton from "@shared/components/SnButton";
import { showPopupModal } from "@widgets/CommonModal";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import SN_PUR_BAS_REG_002_POP_01 from "src/features/pages/menu/PUR/SN_PUR_BAS_REG_002/SN_PUR_BAS_REG_002_POP_01";
import SearchPanel from "@widgets/SearchPanel";
import { parse, isValid } from "date-fns";
import { dateToString, stringToDate } from "@shared/utils/DateUtils";
import { ProcessCellForExportParams } from "ag-grid-community";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

// 엑셀 업로드 시 기존 데이터 여부를 판정할 PK 조합 (mas_umitem)
const UPLOAD_PK_FIELDS = [
  "cd_firm",
  "cd_module",
  "tp_um",
  "cd_exch",
  "cd_item",
  "dt_start",
];

// 엑셀 업로드 오류체크(필수값) 대상 컬럼
// 품목코드, 환종, 단가유형, 단가, 부가세포함단가, 시작일
const UPLOAD_REQUIRED_FIELDS = [
  "cd_item",
  "cd_exch",
  "tp_um",
  "um",
  "um_supply",
  "dt_start",
];

// 단가 이력 동일 건 판정 키 (mas_umitem PK 에서 dt_start 제외)
const UM_KEY_FIELDS = ["cd_item", "tp_um", "cd_exch"];
// 이 값들이 비어 있으면 아직 비교할 수 있는 행이 아니다. (환종/단가유형은 공백일 수 있음)
const UM_KEY_REQUIRED_FIELDS = ["cd_item"];
// 아래 컬럼이 바뀌면 기존 단가의 종료일을 다시 맞춰준다.
const UM_KEY_CHANGED_COLUMNS = ["dt_start", ...UM_KEY_FIELDS];

// 종료일 기본값 (행추가 / 엑셀 업로드에서 종료일을 비워둔 경우)
const DEFAULT_DT_END = "21001231";

const SN_PUR_BAS_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const gridref1 = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const searchRef = useRef<any>(null);
  const { userInfo } = global();
  const [dtB, setdtB] = useState<any[]>([]);
  const [gridFocus, setGridFocus] = useState(false);
  // 종료일 자동정리 재진입 방지
  const syncingRef = useRef<boolean>(false);
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelDownLoad,
    onExcelUpload,
  }));
  //#region onSearch
  const onSearch = async () => {
    const modifiedRows = gridref1.current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved = await onSave();
        if (!isSaved) {
          return;
        }
      }
    }
    try {
      const params = {
        id: "sn_pur_bas_reg_002_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setdtB(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region onInsert
  const onInsert = () => {
    const newRow = {};
    gridref1.current.addRow(newRow);
    gridref1.current.selectAndFocusRow(gridref1.current.rowCount - 1);
    setTimeout(() => {
      gridref1.current.api.setFocusedCell(
        gridref1.current.api.getDisplayedRowCount() - 1,
        "cd_item"
      );
    }, 50);
  };

  //#region onDelete
  const onDelete = () => {
    if (gridref1.current.api.getDisplayedRowCount() === 0) return;
    gridref1.current?.deleteSelectedRows();
  };
  //#region onSave
  const onSave = async () => {
    try {
      let masUmItem;
      gridref1.current.api.stopEditing();
      await new Promise((resolve) => setTimeout(resolve, 0));
      const requiredValuesCheck = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }
      masUmItem = withAdjustedEndDates();
      if (masUmItem.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const ischecked = await checkDt();
      if (!ischecked) return;

      for (const row of gridref1.current.api.getRenderedNodes()) {
        if (row.data?.state !== "insert") continue;
        const sqlQuery = {
          sql: "select case when count(*) = 0  then 'N' else 'Y' end as yn_check from mas_umitem where cd_firm = :cd_firm and cd_module = 'PUR' and tp_um = :p_um and cd_exch = :cd_exch and cd_item = :cd_item and dt_start = :dt_start limit 1",
          cd_firm: userInfo.cd_firm,
          tp_um: row.data?.tp_um,
          cd_exch: row.data?.cd_exch,
          cd_item: row.data?.cd_item,
          dt_start: row.data?.dt_start,
        };
        const result = await getTablebySql(sqlQuery);
        //duplicate checking from database
        if (result[0]["yn_check"] === "Y") {
          showDialog(
            "error",
            `이미 등록된 데이터입니다. 다시 확인해주시기 바랍니다.\n단가유형 = ${row.data?.tp_um} 품목코드 ${row.data?.cd_item} 시작일 = ${row.data?.dt_start}`
          );
          return;
        }

        let qt_cnt: number = 0;

        for (const node of gridref1.current.api.getRenderedNodes()) {
          if (
            row.data?.cd_module === node.data?.cd_module &&
            row.data?.tp_um === node.data?.tp_um &&
            row.data?.cd_exch === node.data?.cd_exch &&
            row.data?.cd_item === node.data?.cd_item &&
            row.data?.dt_start === node.data?.dt_start
          ) {
            qt_cnt++;
            //duplicate checking from grid
            if (qt_cnt > 1) {
              showDialog(
                "error",
                `이미 등록된 데이터입니다. 다시 확인해주시기 바랍니다.\n단가유형 = ${row.data?.tp_um} 품목코드 ${row.data?.cd_item} 시작일 = ${row.data?.dt_start}`
              );
              return;
            }
          }
        }
      }

      const SaveData = {
        mas_umitem: masUmItem,
      };
      await fnSave("SN_PUR_BAS_REG_002_SAVE_01", SaveData);
      gridref1.current.resetUpdate();
      return true;
    } catch (error: any) {}
  };
  //#region initNewRow
  const onBeforeAddRowG1 = (newRow: RowData): boolean => {
    try {
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        tp_um: selectedFormData.tp_um,
        cd_exch: selectedFormData.cd_exch,
      };
      let tp_um_vale = selectedData?.tp_um;
      if (tp_um_vale === "") {
        tp_um_vale = "001";
      }
      let cd_exch_value = selectedData?.cd_exch;
      if (cd_exch_value === "") {
        cd_exch_value = "000";
      }

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_module: "PUR",
        cd_user_reg: userInfo.cd_user,
        tp_um: tp_um_vale,
        cd_exch: cd_exch_value,
        dt_start: todayform,
        dt_end: DEFAULT_DT_END,
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };
  //#region CellChanged
  const onCellValueChanged = async (event: any) => {
    if (!event) return;
    const gridApiH = gridref1.current.api;
    const updatedColumnId = event.column.getColId();
    const updatedRow = event.data;

    if (updatedColumnId === "um") {
      event.node.setDataValue("um_supply", Number(updatedRow.um) * 1.1);
    }
    if (updatedColumnId === "um_supply") {
      event.node.setDataValue("um", (Number(updatedRow.um_supply) * 10) / 11);
    }
    if (UM_KEY_CHANGED_COLUMNS.includes(updatedColumnId)) {
      syncEndDates();
    }
  };
  //#region btnClicking
  const onGridBtnsClick = async (id: string) => {
    if (id === "popup") {
      if (gridref1.current.api.getDisplayedRowCount() === 0) return;
      const selectedData = {
        cd_exch: gridref1.current.api.getSelectedNodes()[0].data?.cd_exch,
      };
      const component = (
        <SN_PUR_BAS_REG_002_POP_01 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "단가일괄조정",
        children: component,
        validation: true,
        width: "50%",
        height: "53vh",
      });
      if (!result || result === "close") return;

      //distinct cd_item from displayed rows and store in ( ''|''|''|)
      const cdItems = dtB.map((row: any) => row.cd_item);

      const uniqueCdItems = Array.from(new Set(cdItems));

      const CdItem = uniqueCdItems.join("|");

      const newData = {
        cd_firm: userInfo.cd_firm,
        cd_item: CdItem,
        cd_exch: result[0].cd_exch,
        tp_um: result[0].tp_um1,
        am: Number(result[0].am),
        seperator: Number(result[0].sepreator1),
        seperator2: Number(result[0].sepreator2),
        dt_from: result[0].dt_from,
        dt_to: result[0].dt_to,
        dtDayStartCrt: result[0].dtDayStartCrt,
        dtDayEndCrt: result[0].dtDayEndCrt,
      };

      const params = {
        id: "sn_pur_bas_reg_002_02",
        params: newData,
      };

      const data: any = await fnGetDataSet(params);

      const headerResult = data[0];
      if (!headerResult) return;
      headerResult.map((result: any) => {
        onAddRow();
        const rowCount = gridref1.current.api.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;

        // 마지막 행에 대한 rowNode를 가져오기
        const lastRowNode =
          gridref1.current.api.getDisplayedRowAtIndex(lastRowIndex);

        if (lastRowNode) {
          gridref1.current.setValue(lastRowNode, "cd_item", result.cd_item);
          gridref1.current.setValue(lastRowNode, "nm_item", result.nm_item);
          gridref1.current.setValue(
            lastRowNode,
            "dc_item_spec",
            result.dc_item_spec
          );
          gridref1.current.setValue(
            lastRowNode,
            "dc_item_unit",
            result.dc_item_unit
          );
          gridref1.current.setValue(lastRowNode, "cd_exch", result.cd_exch);
          gridref1.current.setValue(lastRowNode, "tp_um", result.tp_um);
          gridref1.current.setValue(
            lastRowNode,
            "dt_start",
            result.dt_crt_from
          );
          gridref1.current.setValue(lastRowNode, "dt_end", result.dt_crt_end);
          gridref1.current.setValue(lastRowNode, "um", result.um);
        }
      });
    }
  };
  /**
   * 엑셀 다운로드 컬럼.
   * 엑셀 업로드 시트와 같은 구성(표시 컬럼)·순서(no_seq)로 내려서,
   * 받은 파일을 그대로 업로드에 붙여넣을 수 있게 한다.
   * (업로드는 붙여넣기 기준이라 컬럼 순서가 다르면 값이 밀린다)
   */
  const getDownloadColumnKeys = (): string[] =>
    [...(columns ?? [])]
      .filter((col: any) => col?.cd_column && col.fg_visible === "Y")
      .sort((a: any, b: any) => (a.no_seq ?? 0) - (b.no_seq ?? 0))
      .map((col: any) => col.cd_column);

  //#region onExlDnLoad
  const onExcelDownLoad = async () => {
    try {
      const columnKeys = getDownloadColumnKeys();

      const flatRowMap = gridref1.current.getFlatDataFromGrid(columnKeys);

      gridref1.current?.api.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: globalMenu.getState().activeMenuInfo.nm_menu + ".xlsx",
        sheetName: "Sheet1",
        processCellCallback: (params: ProcessCellForExportParams) => {
          const row = flatRowMap.get(params.node?.id ?? "");
          return row?.[params.column.getColId()]?.value ?? "";
        },
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region onExcelUpload
  const onExcelUpload = async () => {
    try {
      // 업로드 시트는 이 화면의 그리드 컬럼을 그대로 사용한다.
      const component = (
        <ExcelUpload
          Menuprops={Menuprops}
          PkFields={UPLOAD_PK_FIELDS}
          tableName="mas_umitem" // SN_PUR_BAS_REG_002_SAVE_01 이 받는 데이터셋 키
          controllerName="SN_PUR_BAS_REG_002_SAVE_01"
          defaultValue={{
            cd_firm: userInfo.cd_firm,
            cd_module: "PUR",
            cd_user_reg: userInfo.cd_user,
            // 종료일을 비워두고 올리면 행추가와 같은 기본값이 들어간다.
            dt_end: DEFAULT_DT_END,
          }}
          columnConfig={columns}
          requiredFields={UPLOAD_REQUIRED_FIELDS}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result?.excelUpload) {
        await onSearch();
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region othersMethod

  const onAddRow = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridref1.current?.addRow(newRow);
    } catch (error: any) {}
  };
  // 날짜값을 yyyyMMdd 숫자만 남긴 문자열로 정규화 (2026/09/30, 2026-09-30 모두 허용)
  const toYmd = (value: any): string =>
    (value ?? "").toString().replace(/[^0-9]/g, "");

  // 코드값 비교용 정규화 (타입/공백 차이 무시)
  const toKey = (value: any): string => (value ?? "").toString().trim();

  // yyyyMMdd 의 하루 전날
  const getPrevDay = (ymd: string): string => {
    const date = stringToDate(ymd);
    date.setDate(date.getDate() - 1);
    return dateToString(date);
  };

  /**
   * 같은 단가 건인지 판정.
   * 품목은 반드시 일치해야 하고, 단가유형·환종은 한쪽이 비어 있으면
   * (조회조건 미선택 등으로 값이 안 채워진 경우) 같은 건으로 본다.
   */
  const isSameUmKey = (a: any, b: any): boolean =>
    UM_KEY_FIELDS.every((field) => {
      const va = toKey(a[field]);
      const vb = toKey(b[field]);
      if (UM_KEY_REQUIRED_FIELDS.includes(field)) return va === vb;
      if (!va || !vb) return true;
      return va === vb;
    });

  const setEndDate = (node: any, value: string) => {
    gridref1.current.setValue(node, "dt_end", value);
    // 컬럼 설정(valueSetter 등)으로 반영이 안 되는 경우가 있어 직접 반영한다.
    if (toYmd(node.data?.dt_end) !== value) {
      node.data.dt_end = value;
      gridref1.current.api.applyTransaction({ update: [node.data] });
    }
  };

  /**
   * 단가 이력 정리.
   * 같은 건(품목+단가유형+환종)끼리 시작일 순으로 줄 세워서,
   * 앞 행의 종료일을 바로 뒤 행 시작일의 하루 전날로 맞춘다.
   * (바로 뒤 행이 있는 경우 항상 종료일을 그 하루 전날로 맞춘다)
   * 종료일이 바뀐 행 데이터를 돌려준다.
   */
  const syncEndDates = (): any[] => {
    const changed: any[] = [];
    const api = gridref1.current?.api;
    if (!api || syncingRef.current) return changed;

    syncingRef.current = true;
    try {
      const groups = new Map<string, any[]>();
      api.forEachNode((node: any) => {
        if (node.rowPinned) return;
        const data = node.data;
        if (!data) return;
        if (UM_KEY_REQUIRED_FIELDS.some((field) => !toKey(data[field]))) return;
        if (toYmd(data.dt_start).length !== 8) return;

        const key = UM_KEY_REQUIRED_FIELDS.map((field) =>
          toKey(data[field])
        ).join("|");
        const list = groups.get(key) ?? [];
        list.push(node);
        groups.set(key, list);
      });

      groups.forEach((nodes) => {
        if (nodes.length < 2) return;
        nodes.sort((a: any, b: any) =>
          toYmd(a.data.dt_start).localeCompare(toYmd(b.data.dt_start))
        );

        nodes.forEach((node: any, index: number) => {
          const startYmd = toYmd(node.data.dt_start);
          const next = nodes
            .slice(index + 1)
            .find(
              (other: any) =>
                isSameUmKey(node.data, other.data) &&
                toYmd(other.data.dt_start) > startYmd
            );
          if (!next) return;

          const nextStart = toYmd(next.data.dt_start);
          const prevDay = getPrevDay(nextStart);
          const endYmd = toYmd(node.data.dt_end);

          if (endYmd === prevDay) return; // 이미 맞음

          setEndDate(node, prevDay);
          changed.push(node.data);
        });
      });
    } finally {
      syncingRef.current = false;
    }

    return changed;
  };

  /**
   * 저장 직전 처리.
   * 종료일을 정리하고, 바뀐 행을 수정목록에 직접 합쳐서 저장 데이터로 돌려준다.
   * (그리드 변경추적에서 누락되더라도 저장에서 빠지지 않게 한다)
   */
  const withAdjustedEndDates = () => {
    const adjusted = syncEndDates();
    const changes = gridref1.current?.getChange();
    if (!changes) return changes;
    const update = [...(changes.update ?? [])];
    adjusted.forEach((row) => {
      if (!update.includes(row)) update.push(row);
    });

    return {
      ...changes,
      update,
      modifiedRowcount:
        (changes.insert?.length ?? 0) +
        update.length +
        (changes.delete?.length ?? 0),
    };
  };

  const checkDt = async () => {
    const renderedRows = gridref1.current.api.getRenderedNodes();
    for (const node of renderedRows) {
      const dtStartStr = node.data?.dt_start;
      const dtEndStr = node.data?.dt_end;
      if (
        (dtStartStr === "" ||
          dtStartStr === null ||
          dtStartStr === undefined) &&
        (dtEndStr === "" || dtEndStr === null || dtEndStr === undefined)
      ) {
        setTimeout(() => {
          gridref1.current.api.setFocusedCell(node.data?.rowIndex, "dt_start");
        }, 50);
        return false;
      }
      if (dtEndStr === "" || dtEndStr === null || dtEndStr === undefined) {
        continue;
      }
      const formats = [
        "yyyyMMdd",
        "yyyy-MM-dd a h:mm:ss",
        "yyyy-MM-dd HH:mm:ss",
      ];

      const dtStart = tryParseExact(dtStartStr, formats);
      const dtEnd = tryParseExact(dtEndStr, formats);

      if (!dtStart || !dtEnd) {
        return false;
      }
      if (dtEnd < dtStart) {
        showDialog(
          "alter",
          "종료일은 시작일보다 빠를 수 없습니다.\n다시 확인하여 주시기 바랍니다."
        );
        setTimeout(() => {
          gridref1.current.api.setFocusedCell(node?.rowIndex, "dt_end");
        }, 50);
        return false;
      }
    }

    return true;
  };

  function tryParseExact(dateStr: string, formats: string[]): Date | null {
    for (const format of formats) {
      const parsed = parse(dateStr, format, new Date());
      if (isValid(parsed)) {
        return parsed;
      }
    }
    return null;
  }
  //#region rightClick
  const handleContextMenu = async (params: any) => {
    //??
  };
  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="w-full mt-1 mb-1 flex justify-end ">
        <SnButton
          text="단가일괄적용"
          onClick={() => {
            onGridBtnsClick("popup");
          }}
        ></SnButton>
      </div>
      <div className="flex-1">
        <SnAgGrid
          ref={gridref1}
          
          enableAddRow={true}
          columnConfig={columns}
          rowData={dataSource1}
          enableExternalChart={false}
          onBeforeAddRow={onBeforeAddRowG1}
          onCellValueChanged={onCellValueChanged}
          onContextMenu={handleContextMenu}
          isEditable={true}
          rowSelection="single"
        />
      </div>
    </div>
  );
});

export default SN_PUR_BAS_REG_002;
